import { Row } from "antd";
import { RosterAndStaffButton } from "components/Shared/RosterAndStaffButton";
import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";
import { Link } from "react-router-dom";
import { FixturesButton } from "~pages/TeamManager/Dashboard/components/FixturesButton";

export const useSeasonsColumns = () => {
  const {
    createCompetitionNameColumn,
    createSeasonNameColumn,
    createGenderColumn,
    createSeasonStartDateColumn,
    createSeasonEndDateColumn,
    createSeasonAgeGroupColumn,
    createSeasonYearColumn,
    createTaskStatusColumn,
    createSeasonStatusColumn,
  } = useSharedColumnBuilder();

  return [
    createSeasonYearColumn(),
    createCompetitionNameColumn(),
    createSeasonNameColumn(),
    createGenderColumn(),
    createSeasonAgeGroupColumn(),
    createSeasonStartDateColumn(),
    createSeasonEndDateColumn(),
    createSeasonStatusColumn(),
    createTaskStatusColumn(),
    {
      width: 225,
      align: "right",
      render: (record: any) => {
        return (
          <Row justify={"space-between"}>
            <Link to={`seasons/${record?.seasonId}/fixtures`}>
              <FixturesButton season={record} />
            </Link>
            <Link to={`seasons/${record?.seasonId}`}>
              <RosterAndStaffButton disabled={!record?.areRosterAndStaffEditable} />
            </Link>
          </Row>
        );
      },
    },
  ];
};
